export default "__VITE_ASSET__CYEJDfZ7__"